
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app
	.factory('Session', SessionFactory);

	function SessionFactory($state) {
		'ngInject';

		let self = {
			enabled: true
		};

		self.$state = $state;

		self.create = function(userName){
			let updates = {};

			updates = {
				user: userName,
				dialogMatemagico: true,
				endGame: false,
				stages:[
				{
					name: "Oeste",
					route: "stages.stage-one",
					unlocked: true,
					completed: false
				},
				{
					name: "Oeste-2",
					route: "stages.stage-one",
					unlocked: false,
					completed: false
				},
				{
					name: "Leste",
					route: "stages.stage-two",
					unlocked: false,
					completed: false
				},
				{
					name: "Leste-2",
					route: "stages.stage-two",
					unlocked: false,
					completed: false
				},
				{
					name: "Montanha",
					route: "stages.stage-three",
					unlocked: false,
					completed: false
				}
				],
			};

			return sessionStorage.$session = JSON.stringify(updates);
		};

		self.save = function(updates, all){
			if(all){
				sessionStorage.$session = JSON.stringify(updates);
			} else{
				sessionStorage.$session = JSON.stringify({ user: self.get().user, stages: updates.stages, dialogMatemagico: self.get().dialogMatemagico, endGame: self.get().endGame });
			}
			return; 
		};

		self.setDialog = function(bol) {
			sessionStorage.$session = JSON.stringify({ user: self.get().user, stages: self.get().stages, dialogMatemagico: bol, endGame: self.get().endGame });
		}

		self.setEndGame = function(bol) {
			sessionStorage.$session = JSON.stringify({ user: self.get().user, stages: self.get().stages, dialogMatemagico: self.get().dialogMatemagico, endGame: bol });
		}

		self.get = function(){
			try {      
				return JSON.parse(sessionStorage.$session);
			} catch (error) {
				return undefined;
			}
		};

		self.destroy = function(){
			delete sessionStorage.$session;
			return $state.go('login');
		};

		return self;
	}
}



// WEBPACK FOOTER //
// ./src/app/core/services/session.factory.js